module.exports = __webpack_public_path__ + "img/xyd_02.9998ad6f.png";